import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    gallery: 'hidden sm:block'
  }
});
